<template>
  <b-container>
    <b-row>
      <b-col cols="4" class="bar">
        <div class="bottom-bar">
          <div class="upper-bar" :style="chartLevel" />
          <span class="bar-level">
            {{ level === 'N/A' ? level : Math.abs(level).toFixed(0) + '%' }}
          </span>
        </div>
      </b-col>
      <b-col cols="8" class="infos pl-4">
        <div class="details">
          <b-row>
            <span class="header">Informations cadre :</span>
          </b-row>
          <b-row class="align-items-center">
            Ref :
            <b-dropdown
              :text="selectedFrameRef"
              :disabled="!isMaintainer"
              size="sm"
              class="ml-2 my-2"
            >
              <b-dropdown-item
                v-for="item in frameReference"
                :key="item.id"
                @click="handleUpdateFrameReference(item)"
              >
                {{ item.name }}
              </b-dropdown-item>
            </b-dropdown>
          </b-row>
          <!-- <b-row>
            <span>Model : {{ model }}</span>
          </b-row> -->
          <b-row>
            <span>Capacité : {{ capacity }} m3</span>
          </b-row>
          <b-row>
            <span>
              Max H2 >= {{ maxH2 == 0 ? '0' : maxH2 > 0 ? Math.abs(maxH2).toFixed(1) : 'N/A' }}
            </span>
          </b-row>
          <b-row>
            <span>Type d'emballage : {{ packaging }}</span>
          </b-row>
          <!-- <b-row>
            <span>Taille : {{ size }}</span>
          </b-row> -->
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'InfoCadre',
  props: {
    level: {
      type: [Number, String],
      required: false,
      default: 0
    },
    model: {
      type: String,
      required: true
    },
    maxH2: {
      type: Number,
      required: false
    },
    packaging: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: true
    },
    pressure: {
      type: Number,
      required: false
    },
    capacity: {
      type: Number,
      required: false
    },
    channelId: {
      type: String,
      required: true
    },
    selectedFrameRef: {
      type: String,
      required: true
    },
    frameReference: {
      type: Array,
      required: true
    },
    updateFrameReference: {
      type: Function,
      required: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isMaintainer']),
    chartLevel() {
      return `height: ${100 - this.level}%`;
    }
  },
  methods: {
    handleUpdateFrameReference(item) {
      this.$emit('update-frame-reference', this.channelId, item);
    }
  }
};
</script>

<style lang="scss" scoped>
.upper-bar {
  background-color: $byes-black;
}

.bottom-bar {
  background-color: $byes-green;
  position: relative;
  // height: 115px;
  height: 145px;
}

.infos {
  text-align: left;
}

.header {
  font-weight: bold;
}

.details {
  font-size: 0.7rem;
}

.bar {
  color: white;
  font-size: 14px;
}

.bar-level {
  position: absolute;
  top: 45%;
  display: block;
  width: 100%;
}
</style>
